var render = function render(){var _vm=this,_c=_vm._self._c;return _c('be-button',{attrs:{"round":"","flat":"","badge":_vm.hasNotifications,"variant":"secondary"},on:{"click":function($event){return _vm.$router.push({name: 'Notifications'})}}},[_c('i',{staticClass:"icon-be-notification"})])
}
var staticRenderFns = []

export { render, staticRenderFns }